<app-loading *ngIf="contentReady"></app-loading>

<section class="login-wrapper bb-page" [class.bb-login-rtl]="isAr">

  <!-- Canvas Background -->
  <canvas #heroCanvas class="bg-canvas"></canvas>

  <div class="login-card bb-card" *ngIf="!loggedIn">

    <div class="bb-login-language">
      <button
        type="button"
        class="bb-login-language-toggle"
        [class.open]="languageDropdownOpen"
        (click)="toggleLanguageDropdown($event)"
      >
        <span class="bb-login-language-current">
          <img [src]="currentLanguageOption.flag" [alt]="currentLanguageOption.label | transloco" />
          <span>{{ currentLanguageOption.label | transloco }}</span>
        </span>
        <i class="fa-solid fa-chevron-down"></i>
      </button>

      <div *ngIf="languageDropdownOpen" class="bb-login-language-menu">
        <button
          type="button"
          class="bb-login-language-option"
          *ngFor="let language of languages"
          [class.active]="currentLanguage === language.code"
          (click)="setLanguage(language.code, $event)"
        >
          <img [src]="language.flag" [alt]="language.label | transloco" />
          <span>{{ language.label | transloco }}</span>
          <i *ngIf="currentLanguage === language.code" class="fa-solid fa-check"></i>
        </button>
      </div>
    </div>

    <div class="bb-login-head">
      <span class="bb-eyebrow">{{ 'BlueBox' | transloco }}</span>

      <h1 class="login-title">
        {{ "Log in" | transloco }}
      </h1>

      <p class="bb-page-subtitle bb-m-0">
        {{ "welcomeinblue" | transloco }}
      </p>
    </div>

    <form class="bb-login-form" [formGroup]="person" (ngSubmit)="onSubmit()">

      <!-- Username -->
      <div class="bb-field">
        <label class="bb-label" for="username">
          {{ "username" | transloco }}
        </label>

        <input
          class="bb-input bb-input-lg"
          type="text"
          id="username"
          formControlName="username"
          placeholder="{{ 'username' | transloco }}"
          [ngClass]="{
            'is-invalid': person.controls['username'].touched && person.controls['username'].errors,
            'is-valid': person.controls['username'].touched && person.controls['username'].errors == null
          }"
        />
      </div>

      <!-- Password -->
      <div class="bb-field">
        <label class="bb-label" for="Password">
          {{ "Password" | transloco }}
        </label>

        <div class="bb-login-password-field">
          <input
            class="bb-input bb-input-lg"
            id="Password"
            [type]="isPasswordVisible ? 'text' : 'password'"
            formControlName="password"
            placeholder="{{ 'Password' | transloco }}"
            [ngClass]="{
              'is-invalid': person.controls['password'].touched && person.controls['password'].errors,
              'is-valid': person.controls['password'].touched && person.controls['password'].errors == null
            }"
          />

          <button
            type="button"
            class="bb-login-password-toggle"
            (click)="togglePasswordVisibility()"
          >
            {{ isPasswordVisible
              ? ('Hide Password' | transloco)
              : ('Show Password' | transloco) }}
          </button>
        </div>
      </div>

      <div class="bb-login-welcome">
        {{ "welcomeinblue" | transloco }}
      </div>

      <button type="submit" class="bb-btn bb-btn-primary bb-w-100 bb-login-submit">
        {{ "Log in" | transloco }}
      </button>

      <div class="bb-login-register">
        <span>{{ "askforacc" | transloco }}</span>

        <a routerLink="/contact-us" class="bb-link-action">
          {{ "Contact Us" | transloco }}
        </a>
      </div>

    </form>

  </div>

</section>
